import BaseAdapter from '@linc-technologies/linced-common/adapters/base';

export default class School extends BaseAdapter {
  namespace = 'schools/v4';
  modelNamePlural = 'school';
}
